export { default } from './DottedLoader';
